/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step3_RuleInputs */

const en_dr_step3_rule = /** @type {(inputs: Dr_Step3_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The scientist's approach: hypothesize, then test — before writing code`)
};

const id_dr_step3_rule = /** @type {(inputs: Dr_Step3_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendekatan ilmuwan: hipotesis dulu, baru uji — sebelum menulis kode`)
};

/**
* | output |
* | --- |
* | "The scientist's approach: hypothesize, then test — before writing code" |
*
* @param {Dr_Step3_RuleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step3_rule = /** @type {((inputs?: Dr_Step3_RuleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step3_RuleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step3_rule(inputs)
	return en_dr_step3_rule(inputs)
});